import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const CommunityGuidelinesPage = () => {
  return (
    <div className="min-h-screen" style={{ background: '#1a1a1e' }}>
      {/* Header */}
      <div className="border-b border-gray-800" style={{ background: '#0f0f11' }}>
        <div className="container-custom py-4">
          <Link to="/"><Button variant="ghost" className="text-purple-400">← Back</Button></Link>
        </div>
      </div>

      {/* Content */}
      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto">
          <Card className="p-8" style={{ background: 'rgba(42, 26, 58, 0.5)', borderColor: 'rgba(138, 43, 226, 0.3)' }}>
            <h1 className="text-4xl font-bold text-white mb-6">RGM Studio Community Guidelines</h1>
            
            <div className="space-y-6 text-gray-300">
              <section>
                <h2 className="text-2xl font-bold text-white mb-3">Welcome to RGM Studio</h2>
                <p className="leading-relaxed">
                  RGM Studio is a platform dedicated to discovering and elevating independent artists worldwide.
                  By joining our community, you agree to follow these guidelines to maintain a respectful,
                  creative, and professional environment.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-3">1. Submission Requirements</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Submit only original music that you own the rights to</li>
                  <li>Provide accurate artist information and contact details</li>
                  <li>Include valid social proof (follow + tag RGM Studio)</li>
                  <li>Submissions reset weekly - resubmit each week if desired</li>
                  <li>Maximum 2 Top-3 placements per artist per month</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-3">2. Respect & Professionalism</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Treat all artists, staff, and community members with respect</li>
                  <li>No harassment, hate speech, or discriminatory behavior</li>
                  <li>Constructive feedback is encouraged; negativity is not</li>
                  <li>Professional communication in all interactions</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-3">3. Content Standards</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>No explicit content without proper warnings</li>
                  <li>No plagiarism or copyright infringement</li>
                  <li>Accurate representation of your work and achievements</li>
                  <li>Professional quality submissions preferred</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-3">4. Platform Use</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>No spam or excessive self-promotion outside your profile</li>
                  <li>No manipulation of play counts, likes, or engagement metrics</li>
                  <li>Respect submission windows and deadlines</li>
                  <li>One account per artist or group</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-3">5. Weekly Selection Process</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Top 3 selections are based on quality, originality, and engagement</li>
                  <li>Minimum score of 45/60 required for eligibility</li>
                  <li>Founder submissions are not eligible for Top 3</li>
                  <li>Admin decisions are final</li>
                  <li>Winners receive Spotlight Winner badge</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-3">6. Consequences</h2>
                <p className="leading-relaxed mb-2">
                  Violation of these guidelines may result in:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Submission rejection</li>
                  <li>Account warning</li>
                  <li>Temporary suspension</li>
                  <li>Permanent ban from the platform</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-3">7. Rights & Ownership</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>You retain all rights to your music and content</li>
                  <li>RGM Studio is a non-exclusive platform</li>
                  <li>We may feature your work in promotional materials</li>
                  <li>No guarantees of placement or exposure</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-3">8. Contact & Support</h2>
                <p className="leading-relaxed">
                  Questions or concerns? Contact us through the Artist Portal or reach out on social media.
                  We're here to support your journey.
                </p>
              </section>

              <div className="mt-8 p-6 bg-purple-900/20 border border-purple-500/30 rounded-lg">
                <p className="text-white font-semibold mb-2">Last Updated: January 2026</p>
                <p className="text-gray-400 text-sm">
                  By using RGM Studio, you acknowledge that you have read, understood, and agree to abide
                  by these Community Guidelines. RGM Studio reserves the right to update these guidelines
                  at any time.
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CommunityGuidelinesPage;